<template>
  <div class="container-down">
    <div class="for-web">
      <img class="bg1" src="~@/assets/packageAssets/views/P4_Page/Down/default/star-big.png" />
      <img class="bg2" src="~@/assets/packageAssets/views/P4_Page/Down/default/earn-big.png" />
      <div class="main">
        <div class="title">{{ $t('lang.down.becomeAHost') }}</div>
        <div class="code">
          <div class="code-copy" @click.prevent="handleCopyCode">
            {{ $t('lang.down.invitationCode') }}
            <span>{{ code }}</span>
            <img src="~@/assets/packageAssets/views/P4_Page/Down/default/copy.png" />
          </div>
        </div>
        <div class="link">
          <div v-if="googleDownItem && googleDownItem.canUse" class="link-item">
            <div class="link-top">
              <img :src="getInnerMatchImg('app-logo', googleDownItem.logo)" />
              {{ googleDownItem.showName }}
            </div>
            <div class="link-store">
              <img src="~@/assets/packageAssets/views/P4_Page/Down/default/google_btn.png" @click="handleDown(googleDownItem)" />
            </div>
          </div>
          <div v-if="appleDownItem && appleDownItem.canUse" class="link-item">
            <div class="link-top">
              <img :src="getInnerMatchImg('app-logo', appleDownItem.logo)" />
              {{ appleDownItem.showName }}
            </div>
            <div class="link-store">
              <img src="~@/assets/packageAssets/views/P4_Page/Down/default/app_store.png" @click="handleDown(appleDownItem)" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="text1">{{ $t('lang.down.tit3') }}</div>
        <div class="text2">{{ $t('lang.down.tit3con1') }}{{ $t('lang.down.tit3con2') }}</div>
      </div>
    </div>
    <div class="for-mobile">
      <img class="bg1" src="~@/assets/packageAssets/views/P4_Page/Down/default/star-small.png" />
      <img class="bg2" src="~@/assets/packageAssets/views/P4_Page/Down/default/earn-small.png" />
      <div class="main">
        <div class="title">{{ $t('lang.down.becomeAHost') }}</div>
        <div class="code">
          <div class="code-copy" @click.prevent="handleCopyCode">
            {{ $t('lang.down.invitationCode') }}
            <span>{{ code }}</span>
            <img src="~@/assets/packageAssets/views/P4_Page/Down/default/copy.png" />
          </div>
        </div>
        <div class="link">
          <div v-if="googleDownItem && googleDownItem.canUse" class="link-item">
            <div class="link-top">
              <img :src="getInnerMatchImg('app-logo', googleDownItem.logo)" />
              {{ googleDownItem.showName }}
            </div>
            <div class="link-store">
              <img src="~@/assets/packageAssets/views/P4_Page/Down/default/google_btn.png" @click="handleDown(googleDownItem)" />
            </div>
          </div>
          <div v-if="appleDownItem && appleDownItem.canUse" class="link-item">
            <div class="link-top">
              <img :src="getInnerMatchImg('app-logo', appleDownItem.logo)" />
              {{ appleDownItem.showName }}
            </div>
            <div class="link-store">
              <img src="~@/assets/packageAssets/views/P4_Page/Down/default/app_store.png" @click="handleDown(appleDownItem)" />
            </div>
          </div>
        </div>
        <div class="still-block"></div>
      </div>
      <div class="bottom">
        <div class="text1">{{ $t('lang.down.tit3') }}</div>
        <div class="text2">{{ $t('lang.down.tit3con1') }}{{ $t('lang.down.tit3con2') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import echoLogo from './image/echo/app-logo.png'
import joychatLogo from './image/joychat/app-logo.png'
import joyuLogo from './image/joyu/app-logo.png'
import kikoLogo from './image/kiko/app-logo.png'
import vavaLogo from './image/vava/app-logo.png'
import vibeoLogo from './image/vibeo/app-logo.png'
import whonowLogo from './image/whonow/app-logo.png'

const applogoMap = {
  echo: echoLogo,
  joychat: joychatLogo,
  joyu: joyuLogo,
  kiko: kikoLogo,
  vava: vavaLogo,
  vibeo: vibeoLogo,
  whonow: whonowLogo
}

const downLoadUrlMap = {
  // echo
  echoAndroid: 'https://play.google.com/store/apps/details?id=com.chat.whisper',
  echoIos: 'https://apps.apple.com/cn/app/echo-secret-share-virtual-link/id6479391629',
  // joychat
  joychatAndroid: 'https://play.google.com/store/apps/details?id=com.chat.joychat',
  joychatIos: '',
  // joyu
  joyuAndroid: 'https://play.google.com/store/apps/details?id=com.mind.joyu',
  joyuIos: '',
  // kiko
  kikoAndroid: 'https://play.google.com/store/apps/details?id=com.live.kiko',
  kikoIos: '',
  // vava
  vavaAndroid: 'https://play.google.com/store/apps/details?id=com.client.goparty',
  vavaIos: '',
  // vibeo
  vibeoAndroid: 'https://play.google.com/store/apps/details?id=com.live.vibeo',
  vibeoIos: '',
  // whonow
  whonowAndroid: '',
  whonowIos: ''
}
export default {
  data() {
    let query = this.$route.query
    return {
      // 链接参数
      channel: query.channel || '',
      appName: query.appName || '',
      lang: query.lang || 'en',
      code: query.code,
      utmSource: 'auto_code_bind',
      // 显示数据
      googleDownItem: {
        canUse: false,
        logo: '',
        showName: '',
        downLoadLink: '',
        needParams: false
      },
      appleDownItem: {
        canUse: false,
        logo: '',
        showName: '',
        downLoadLink: '',
        needParams: false
      }
    }
  },
  methods: {
    getInnerMatchImg(flag, packageName) {
      return applogoMap[packageName] || ''
    },
    fromIosApp() {
      const iosAppName = ['com.fh.whisper.chat', 'com.example.echo']
      return iosAppName.includes(this.appName)
    },
    handleCopyCode() {
      if (this.code) {
        this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      }
    },
    handleDown(item) {
      let tempUrl = item.downLoadLink || ''
      if (item.needParams) {
        tempUrl = `${tempUrl}&referrer=` + encodeURIComponent(`utm_source=${this.utmSource}&utm_medium=${this.code}`)
      }
      this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      window.open(tempUrl)
    },
    init() {
      // vava 和 echo(ios) 显示下载 vava echo
      if (this.packageName === 'vava' || (this.packageName === 'echo' && this.fromIosApp())) {
        this.googleDownItem = {
          canUse: true,
          logo: 'vava',
          showName: 'Vava',
          downLoadLink: downLoadUrlMap.vavaAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: true,
          logo: 'echo',
          showName: 'Echo',
          downLoadLink: downLoadUrlMap.echoIos,
          needParams: false
        }
        return
      }

      if (this.packageName === 'echo') {
        this.googleDownItem = {
          canUse: true,
          logo: 'echo',
          showName: 'Echo',
          downLoadLink: downLoadUrlMap.echoAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'echo',
          showName: 'Echo',
          downLoadLink: downLoadUrlMap.echoIos,
          needParams: false
        }
        return
      }
      if (this.packageName === 'joychat') {
        this.googleDownItem = {
          canUse: true,
          logo: 'joychat',
          showName: 'Joychat',
          downLoadLink: downLoadUrlMap.joychatAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'joychat',
          showName: 'Joychat',
          downLoadLink: downLoadUrlMap.joychatIos,
          needParams: false
        }
        return
      }
      if (this.packageName === 'joyu') {
        this.googleDownItem = {
          canUse: true,
          logo: 'joyu',
          showName: 'Joyu',
          downLoadLink: downLoadUrlMap.joyuAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'joyu',
          showName: 'Joyu',
          downLoadLink: downLoadUrlMap.joyuIos,
          needParams: false
        }
        return
      }
      if (this.packageName === 'kiko') {
        this.googleDownItem = {
          canUse: true,
          logo: 'kiko',
          showName: 'Kiko',
          downLoadLink: downLoadUrlMap.kikoAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'kiko',
          showName: 'Kiko',
          downLoadLink: downLoadUrlMap.kikoIos,
          needParams: false
        }
        return
      }
      if (this.packageName === 'vibeo') {
        this.googleDownItem = {
          canUse: true,
          logo: 'vibeo',
          showName: 'Vibeo',
          downLoadLink: downLoadUrlMap.vibeoAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'vibeo',
          showName: 'Vibeo',
          downLoadLink: downLoadUrlMap.vibeoIos,
          needParams: false
        }
        return
      }
      if (this.packageName === 'whonow') {
        this.googleDownItem = {
          canUse: true,
          logo: 'whonow',
          showName: 'Whonow',
          downLoadLink: downLoadUrlMap.whonowAndroid,
          needParams: true
        }
        this.appleDownItem = {
          canUse: false,
          logo: 'whonow',
          showName: 'Whonow',
          downLoadLink: downLoadUrlMap.whonowIos,
          needParams: false
        }
        return
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-down {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(180deg, #ff4e3b 0%, #491161 100%);

  .for-web {
    width: 100%;
    min-height: 100vh;
    position: relative;
    .bg1 {
      width: 100%;
      max-width: 1440px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
    .bg2 {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
    .main {
      position: relative;
      z-index: 10;
      width: 100%;
      max-width: 1440px;
      min-height: 1100px;
      margin: 0 auto;
      padding-top: 103px;
      .title {
        width: 100%;
        color: #fff;
        font-family: Roboto;
        font-size: 128px;
        font-style: normal;
        font-weight: 700;
        line-height: 150px;
        text-align: center;
      }
      .code {
        width: 100%;
        text-align: center;

        .code-copy {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 12px 24px;

          border-radius: 4px;
          background: #ae2836;
          backdrop-filter: blur(17px);

          color: rgba(255, 255, 255, 0.8);
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          span {
            display: flex;
            padding: 8px 12px;
            margin: 0 12px;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            background: #971735;
          }

          img {
            width: 32px;
            height: 32px;
          }
        }
      }
      .link {
        margin-top: 96px;
        display: flex;
        align-items: center;
        justify-content: center;

        .link-item {
          margin: 0 44px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .link-top {
            display: flex;
            align-items: center;
            justify-content: center;

            color: #fff;
            font-family: Roboto;
            font-size: 32px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;

            img {
              width: 88px;
              height: 88px;
              margin: 0 12px;
            }
          }
          .link-store {
            width: 245px;
            margin-top: 40px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .bottom {
      position: absolute;
      left: 0;
      bottom: 35px;
      z-index: 13;
      width: 100%;
      .text1 {
        width: 100%;
        padding: 0 16px;
        text-align: center;
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      .text2 {
        width: 100%;
        padding: 0 16px;
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .for-mobile {
    display: none;
    width: 100%;
    min-height: 100vh;
    position: relative;
    .bg1 {
      width: 100%;
      max-width: 1440px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
    .bg2 {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
    .main {
      position: relative;
      z-index: 10;
      width: 100%;
      min-height: 100vh;
      margin: 0 auto;
      padding-top: 74px;
      .title {
        width: 100%;
        color: #fff;
        font-family: Roboto;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 50px;
        text-align: center;
      }
      .code {
        margin-top: 24px;
        width: 100%;
        text-align: center;

        .code-copy {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 12px 24px;

          border-radius: 4px;
          background: #ae2836;
          backdrop-filter: blur(17px);

          color: rgba(255, 255, 255, 0.8);
          font-family: Roboto;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          span {
            display: flex;
            padding: 8px 12px;
            margin: 0 12px;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            background: #971735;
          }

          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .link {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .link-item {
          margin: 44px 44px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .link-top {
            display: flex;
            align-items: center;
            justify-content: center;

            color: #fff;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;

            img {
              width: 66px;
              height: 66px;
              margin: 0 9px;
            }
          }
          .link-store {
            width: 183px;
            margin-top: 40px;
            img {
              width: 100%;
            }
          }
        }
      }
      .still-block {
        width: 100%;
        height: 200px;
      }
    }
    .bottom {
      position: absolute;
      left: 0;
      bottom: 10px;
      z-index: 13;
      width: 100%;
      .text1 {
        width: 100%;
        padding: 0 16px;
        text-align: center;
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      .text2 {
        width: 100%;
        padding: 0 26px;
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .container-down {
    .for-web {
      display: none;
    }
    .for-mobile {
      display: block;
    }
  }
}
</style>
